import { render, staticRenderFns } from "./inviteCustomersOrders.vue?vue&type=template&id=05d439ff&scoped=true"
import script from "./inviteCustomersOrders.vue?vue&type=script&lang=js"
export * from "./inviteCustomersOrders.vue?vue&type=script&lang=js"
import style0 from "./inviteCustomersOrders.vue?vue&type=style&index=0&id=05d439ff&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d439ff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05d439ff')) {
      api.createRecord('05d439ff', component.options)
    } else {
      api.reload('05d439ff', component.options)
    }
    module.hot.accept("./inviteCustomersOrders.vue?vue&type=template&id=05d439ff&scoped=true", function () {
      api.rerender('05d439ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/printingPage/sepecialOrderPrint/components/inviteCustomersOrders.vue"
export default component.exports